import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";
import { Http, ResponseContentType } from '@angular/http';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-packageinvoicelist',
  templateUrl: './packageinvoicelist.component.html',
  styleUrls: ['./packageinvoicelist.component.css'],
  providers: [TestSeriesService],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
]
})

export class PackageinvoicelistComponent implements OnInit {
  typetxt:any='';
  packageList:any=[];
  totalrow:any = 0;
  notfound:any;
  isPostLoad:any=true;
  msg:any='';
  isRemaningForum:any;
  postId:any=0;
  ngload:any;
  userData:any;
  filter:any;
  noMoreResults:any;
  isError=false;
  siteUrl = this.global.websiteUrl;
  paperList:any=[];
  streambox:any=[{id:''}];
  isMyPackage = false;
  streamText:any='';
  loggedinUserId:any=0;
  userId = 0;
  invmailsend=false;
  isclickbuttonRegisterprofile=[];

  constructor(private http:Http, private testseriesservice:TestSeriesService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) { 

    this.userId = commonService.user.id;
          this.ngload=true;
          this.packageList=[];
          let filter={};
          filter={limit:2000};
          this.getMyPackageList(filter);
          
  }

  ngOnInit() {
  }

  getMyPackageList(obj){
    obj['orderby']="id";
    obj['offset']=this.packageList.length?this.packageList.length:0;
    obj['userId']=this.userId;
    obj['streamId']=this.typetxt;
   
    this.testseriesservice.getinvoicelist(obj).subscribe((data:any)=>{
     let finaldata = [];
      if(data.error==0){ 
        if(data.results.rows.length > 0){
          /*for(let mypackagedata of data.results.rows){ 
            if(mypackagedata.orderItem) { 
              finaldata.push(mypackagedata.orderItem.testSery);
            }
          }  */
        Array.prototype.push.apply(this.packageList,data.results.rows); 
        console.log('gg',this.packageList);
        this.isPostLoad=false;
      }else{
        this.isRemaningForum=false;
        this.isPostLoad=false;
        this.noMoreResults = true;
        this.packageList = [];
        console.log('cccccc',this.noMoreResults);
      }

      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },(error : HttpErrorResponse)=>{    
      this.isPostLoad=false;  
      this.msg="internal server error!";
    });    
  }

  invoiceUrl(tpid){
    return '../packageinvoice/'+btoa(tpid);
  }


  loadmorePackage(){
    console.log('loadmoreForum');
    this.getMyPackageList({limit:10,isnewList:true});
  }

  @HostListener('window:scroll', ['$event'])
    checkScroll() {
       var scrollPosition = $(window).scrollTop() + $(window).height();
       //var pageheight =  $(document).height()
       var pageheight =  $(document).height()-$('#footer-section').outerHeight();
       if(scrollPosition >= pageheight && this.isRemaningForum==true && this.postId==0 && this.isPostLoad!=true) {
         this.isPostLoad=true;        
         this.loadmorePackage();
       }
 
  }
  private sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  requestuserinvoice(pakagename){
    if(this.userId){
      this.testseriesservice.requestforinvoice(this.userId,pakagename).subscribe((data:any)=>{
        if(data.error==0){
            this.invmailsend=true;
            this.sleep(3000).then(() => {
              this.invmailsend=false;
            })
            
        }
        


      },(error : HttpErrorResponse)=>{    
        this.isPostLoad=false;  
        this.msg="internal server error!";
      }); 

    }
    

  }





}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/packageinvoicelist/packageinvoicelist.component.ts